import { getPartnerPermissions } from '@atlassian/mpac-api-client';
import { hooks, log } from '@atlassian/mpac-utils';

import type { PartnerPermissions } from '@atlassian/mpac-api-client';

export type UsePartnerPermissionsResponse = {
  permissions: PartnerPermissions | null | undefined;
  permissionsError: string | null | undefined;
};

const usePartnerPermissions = (
  mpacBaseUrl: string,
  partnerId: number | string | null | undefined,
  isLoggedIn: boolean
): UsePartnerPermissionsResponse => {
  const { result, error } = hooks.usePromise(() => {
    if (!partnerId || !isLoggedIn) {
      return Promise.resolve(null);
    }
    return getPartnerPermissions(mpacBaseUrl, partnerId);
  }, [partnerId, isLoggedIn]);
  if (error && !(error.status === 403)) {
    log.error('AppListingPage', `Failed to retrieve partner permissions`, {
      error,
    });
  }

  return {
    permissions: result,
    permissionsError: error,
  };
};

export default usePartnerPermissions;
